// @flow
import { authenticatedFetch } from '../../api/request';

export default async function getHeadCoach() {
    return await authenticatedFetch('/v5/headCoach');
}
